module.exports = __webpack_public_path__ + "img/hyphae.b6753855.jpg";